import { useState } from 'react';
import { FcGoogle } from 'react-icons/fc';  
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { signIn, signInWithGoogle } = useAuth();  // aggiungi signInWithGoogle
  const navigate = useNavigate();
  const location = useLocation();
  const message = (location.state as any)?.message;
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    
    try {
      await signIn(email, password);
      const from = (location.state as any)?.from?.pathname || '/';
      navigate(from, { replace: true });
    } catch (err: any) {
      if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password') {
        setError('Email o password non validi');
      } else if (err.code === 'auth/too-many-requests') {
        setError('Troppi tentativi. Riprova più tardi');
      } else {
        setError('Errore durante l\'accesso');
      }
    }
  };

  // Aggiungi questa nuova funzione
  const handleGoogleSignIn = async () => {
    try {
      setIsLoading(true);
      setError('');
      const { isNewUser, hasPizzerie } = await signInWithGoogle();
      
      if (isNewUser && !hasPizzerie) {
        // Nuovo utente senza pizzerie -> mostra setup con offerta trial
        navigate('/admin/pizzerie', { 
          state: { 
            showSetup: true,
            showTrial: true,
            message: 'Benvenuto! Configura la tua prima pizzeria e ricevi uno spicchio in omaggio valido 30 giorni!'
          },
          replace: true
        });
      } else {
        navigate('/admin/pizzerie', { 
          replace: true,
          state: { 
            message: isNewUser 
              ? 'Bentornato! Ecco le tue pizzerie.' 
              : 'Bentornato!'
          }
        });
      }
    } catch (err: any) {
      setError('Errore durante l\'accesso con Google: ' + err.message);
    } finally {
      setIsLoading(false);
    }
};

  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-md w-full">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900">
            Accedi al tuo account
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Oppure{' '}
            <Link to="/register" className="font-medium text-pizzaveg hover:text-pizzaveg-dark transition-colors">
              registrati gratuitamente
            </Link>
          </p>
        </div>

        {message && (
          <div className="mt-4 p-4 rounded-lg bg-green-50 text-green-700 text-sm text-center">
            {message}
          </div>
        )}

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 appearance-none rounded-lg relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-pizzaveg focus:border-pizzaveg"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 appearance-none rounded-lg relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-pizzaveg focus:border-pizzaveg"
              />
            </div>
          </div>

          {error && (
            <div className="text-red-600 text-sm text-center">
              {error}
            </div>
          )}

          <div className="space-y-3">
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-pizzaveg hover:bg-pizzaveg-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pizzaveg transition-colors duration-200 ease-in-out"
            >
              Accedi
            </button>

            {/* Aggiungi questo nuovo pulsante */}
            <button
  type="button"
  onClick={handleGoogleSignIn}
  disabled={isLoading}
  className="w-full flex items-center justify-center gap-2 py-2 px-4 border border-gray-300 text-sm font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pizzaveg transition-colors duration-200 ease-in-out"
>
  <FcGoogle className="w-5 h-5" />
  {isLoading ? (
    <span className="flex items-center gap-2">
      <svg className="animate-spin h-5 w-5 text-pizzaveg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Accesso in corso...
    </span>
  ) : (
    'Accedi con Google'
  )}
</button>
          </div>
        </form>
      </div>
    </div>
  );
}